import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const TOGGLE_REASSIGN_WHS_DOCUMENT_MODAL = 'TOGGLE_REASSIGN_WHS_DOCUMENT_MODAL';

function openReassignWhsDocumentModal(formId, originalFileName) {
  return {
    type: TOGGLE_REASSIGN_WHS_DOCUMENT_MODAL,
    isReassignWhsDocumentModalShown: true,
    reassignWhsDocumentFormId: formId,
    reassignWhsDocumentFormOriginalFileName: originalFileName
  };
}

function closeReassignWhsDocumentModal() {
  return {
    type: TOGGLE_REASSIGN_WHS_DOCUMENT_MODAL,
    isReassignWhsDocumentModalShown: false
  };
}

export function showReassignWhsDocumentModal(formId, originalFileName) {
  return (dispatch) => {
    dispatch(openReassignWhsDocumentModal(formId, originalFileName));
  };
}

export function hideReassignWhsDocumentModal() {
  return (dispatch) => {
    dispatch(closeReassignWhsDocumentModal());
  };
}

export function reassignWhsDocumentForm(formId, newBoId, callback) {
  return (dispatch) => {
    const promise = () => ApiService
      .reassignForm(formId, newBoId)
      .then((response) => {
        const action = dispatch(closeReassignWhsDocumentModal());
        if (callback) {
          callback();
        }
        return action;
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, closeReassignWhsDocumentModal, true));
        }
      });
    return promise();
  };
}
